import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alphabeticalSort',
  standalone: true,
})
export class AlphabeticalSortPipe implements PipeTransform {
  transform(value: any[], field?: string): any[] {
    if (!Array.isArray(value)) return value;

    return value.sort((a, b) => {
      // If a specific field is provided, sort based on that field
      const textA = field ? a[field].toString().toLowerCase() : a.toString().toLowerCase();
      const textB = field ? b[field].toString().toLowerCase() : b.toString().toLowerCase();
      return textA.localeCompare(textB);
    });
  }
}
